import { FormContainerComponent } from './Forms'

export type CtaVariant = 'loggedOut' | 'ineligibleCart' | 'loggedIn'

export type CtaSubVariant =
  | 'DEFAULT'
  | 'IN_PROGRESS'
  | 'ACCEPTED'
  | 'REJECTED'
  | 'ACKNOWLEDGED_NULLIFIED'
  | 'NULLIFIED'
  | 'TIMEOUT_RETRY'
  | 'LIMIT_REACHED'
  | 'SERVICE_OFFLINE'
  | 'NULLIFY_REJECTED'

/**
 * JSON configuration for the different CTA states
 */
export interface CtaConfiguration {
  loggedOut: FormContainerComponent
  ineligibleCart: FormContainerComponent
  loggedIn: {
    DEFAULT: FormContainerComponent
    IN_PROGRESS: FormContainerComponent
    ACCEPTED: FormContainerComponent
    REJECTED: FormContainerComponent
    ACKNOWLEDGED_NULLIFIED?: FormContainerComponent
    NULLIFIED?: FormContainerComponent
    TIMEOUT_RETRY?: FormContainerComponent
    LIMIT_REACHED: FormContainerComponent
    SERVICE_OFFLINE?: FormContainerComponent
    NULLIFY_REJECTED?: FormContainerComponent
  }
}

export enum CtaError {
  GENERIC_ERROR = 'GENERIC_ERROR',
  NULLIFY_EXPIRED = 'NULLIFY_EXPIRED',
  INIT_ERROR = 'INIT_ERROR',
  NONE = 'NONE',
}
